<template>
  <div class="min-h-screen bg-slate-50 font-sans">
    <header class="bg-white/80 backdrop-blur-md border-b border-slate-200 sticky top-0 z-50">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div class="flex items-center gap-8">
          <!-- Logo/Text -->
          <NuxtLink to="/" class="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <img src="/logo.png" alt="ClaimReady" class="h-8 w-auto">
          </NuxtLink>
        </div>

        <!-- Actions -->
        <div class="flex items-center gap-4">
          <UButton color="primary" variant="solid" label="Start Inventory" size="sm" @click="createNewReport" />
        </div>
      </div>
    </header>

    <main class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <slot />
    </main>
    <AppFooter />
  </div>
</template>

<script setup lang="ts">
import { useInventoryStore } from '~/stores/inventory'

const inventoryStore = useInventoryStore()

const createNewReport = async () => {
  const reportId = await inventoryStore.createReport()
  navigateTo(`/reports/${reportId}`)
}
</script>
